export type ReviewResponse = {
    ReviewSubmittedTS: number;
    accuracy: number;
    bidderCity: string;
    bidderCountry: string;
    bidderFirstName: string;
    bidderId: number;
    bidderLastName: string;
    bidderState: string;
    catalogId: number;
    catalogName: string;
    note: string;
    overall: number;
    payment: number;
    responsiveness: number;
    review: string;
    reviewHeadline: string;
    reviewId: number;
    reviewSubmitted: string;
    reviewSubmittedTs: number;
    sellerId: number;
    shipping: number;
    wonItems: ReviewWonItem[];
};

export type ReviewSubmit = {
    accuracy: number;
    bidderId: number;
    catalogId: number;
    note: string;
    overall: number;
    payment: number;
    responsiveness: number;
    review: string;
    reviewHeadline: string;
    sellerId: number;
    shipping: number;
};

export enum ReviewCommentPrivacyStatus {
    Private = 'private',
    Public = 'public',
}

export type ReviewComment = {
    bidderId: number;
    comment: string;
    commentId: number;
    commentSubmitted: string;
    commentSubmittedTS: number;
    houseId: number;
    privacyStatus: ReviewCommentPrivacyStatus;
    reviewId: number;
    userDisplayName: string;
    userId: number;
    userType: string;
};

export type ReviewWonItem = {
    bidderId: number;
    catalogId: number;
    itemId: number;
    title: string;
};
